import { createSvgIcon } from "@material-ui/core/utils";
import React from "react";

export const ColumnsIcon = createSvgIcon(
  <path
    d="M9 3H5C3.89543 3 3 3.89543 3 5V19C3 20.1046 3.89543 21 5 21H9M9 3V21M9 3H15M9 21H15M15 21H19C20.1046 21 21 20.1046 21 19V5C21 3.89543 20.1046 3 19 3H15M15 21V3"
    stroke="currentColor"
    strokeWidth="2"
    fill="transparent"
  />,
  "ColumnsIcon"
);
